import { useTimezone } from '@app/core/hooks/useTimezone';
import { ListView } from '@app/core/list-view/ListView';
import { ListViewQueryParams } from '@app/core/list-view/types';
import { Station } from '@app/core/types/stations';
import { AuditAudio, Paginated } from '@mi-front/core';
import { apiClient } from '../../../../../../api';
import { AUDIOS_LIST_FILTERS_CONFIG } from './audios-filters-config';
import { audiosListFiltersToApi, audiosListSortToApi } from './map-audios-list-query';
import { AudiosListResult } from './AudiosListResult';

interface Props {
  readonly station: Station;
}

/**
 * Station-scoped audios listing using ListView (preset date range + material ID text filter).
 */
export function AudiosListView({ station }: Props) {
  const timezone = useTimezone();

  const queryFn = async (params: ListViewQueryParams): Promise<Paginated<AuditAudio>> => {
    return apiClient.audit.fetchAudios({
      stationId: station.slug,
      page: params.pageIndex,
      pageSize: params.pageSize,
      sort: audiosListSortToApi(params.sort),
      filter: audiosListFiltersToApi(params.filters, timezone),
    });
  };

  return (
    <ListView
      listId={`audit-audios-list-${station.slug}`}
      filters={AUDIOS_LIST_FILTERS_CONFIG}
      queryFn={queryFn}
      ListComponent={AudiosListResult}
      stickyFilters={false}
    />
  );
}
